var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaregivers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-caregivers"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3723",
    "data-name": "Path 3723",
    d: "M991-594a5,5,0,0,1,5,5h0v2a1,1,0,0,1-1,1,1,1,0,0,1-1-1h0v-2a3,3,0,0,0-3-3h-8a3,3,0,0,0-3,3h0v2a1,1,0,0,1-1,1,1,1,0,0,1-1-1h0v-2a5,5,0,0,1,5-5h8Zm6.032.88a1,1,0,0,1,1.218-.718A5,5,0,0,1,1002-589h0v2a1,1,0,0,1-1,1,1,1,0,0,1-1-1h0v-2a3,3,0,0,0-2.25-2.9A1,1,0,0,1,997.032-593.12ZM987-606a5,5,0,0,1,5,5,5,5,0,0,1-5,5,5,5,0,0,1-5-5A5,5,0,0,1,987-606Zm6.031.882a1,1,0,0,1,1.217-.721,5,5,0,0,1,3.76,4.844,5,5,0,0,1-3.76,4.844,1,1,0,0,1-1.217-.721,1,1,0,0,1,.721-1.217,3,3,0,0,0,2.256-2.906,3,3,0,0,0-2.256-2.906A1,1,0,0,1,993.031-605.118ZM987-604a3,3,0,0,0-3,3,3,3,0,0,0,3,3,3,3,0,0,0,3-3A3,3,0,0,0,987-604Z",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2-caregivers"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2735",
    "data-name": "Rectangle 2735",
    width: 27,
    height: 22,
    transform: "translate(977 -607)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3-caregivers"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3720",
    "data-name": "Path 3720",
    d: "M978-586h25v-20H978Z",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4-caregivers"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3722",
    "data-name": "Path 3722",
    d: "M978-586h24v-20H978Z",
    fill: "#00142e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3873",
    "data-name": "Group 3873",
    transform: "translate(-978 606)",
    clipPath: "url(#clip-path-caregivers)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3872",
    "data-name": "Group 3872",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3871",
    "data-name": "Group 3871",
    clipPath: "url(#clip-path-2-caregivers)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3869",
    "data-name": "Group 3869",
    clipPath: "url(#clip-path-3-caregivers)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3719",
    "data-name": "Path 3719",
    d: "M977-607h27v22H977Z",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3870",
    "data-name": "Group 3870",
    clipPath: "url(#clip-path-4-caregivers)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3721",
    "data-name": "Path 3721",
    d: "M977-607h26v22H977Z",
    fill: "#00142e"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaregivers);
export default __webpack_public_path__ + "static/media/caregivers.f589c149.svg";
export { ForwardRef as ReactComponent };